import React from 'react'
import { withRouter } from 'react-router-dom'

const Confirmation = (props) => {
  const { type } = (props.location.state || {})
  return (
    <div className="uk-padding">
      <button
        className="uk-button uk-button-secondary uk-button-small uk-flex uk-flex-center uk-flex-middle"
        onClick={() => {
          props.history.replace('/')
        }}
      >
        <i className="ri-arrow-left-s-line uk-margin-small-right" name="arrow-left-s"></i>
        See Full Plan
      </button>
      <div className="uk-text-emphasis uk-text-center">
        <span>🎉 Congrats!</span>
        <p>
          {type === 'crypto' ? 'We will transfer your BTC shortly!' : 'You should receive an email with instructions on how to redeem your Gift Card shortly!'}
        </p>
      </div>
    </div>
  )
}

export default withRouter(Confirmation)
